<template>
  <v-card>
    <!-- tab control -->
    <v-card class="d-flex justify-space-around align-center">
      <div v-if="title" bottom class="text-h7">{{ title }}</div>
      <div bottom class="text-h5">Pedidos</div>
      <div>
        <v-tabs v-model="currentTab">
          <v-tab :disabled="editMode === 'edit' || editMode === 'new'">
            Lista
          </v-tab>
          <v-tab :disabled="!currentItem">Edición</v-tab>
        </v-tabs>
      </div>
      <div v-show="currentTab === 1">
        <v-btn
          v-show="editMode !== 'show'"
          :disabled="onAction == true"
          color="warning"
          outlined
          @click="cancel"
          class="mx-2"
        >
          Cancelar
        </v-btn>
        <v-btn
          v-show="editMode === 'show' && canEdit"
          :disabled="onAction == true"
          color="success"
          outlined
          @click="edit"
          class="mx-2"
        >
          Editar
        </v-btn>
        <v-btn
          v-show="editMode !== 'show'"
          :disabled="onAction == true"
          color="success"
          outlined
          @click="save"
          class="mx-2"
        >
          Guardar
        </v-btn>
        <v-btn
          v-show="editMode == 'show' && canRequestInvoicing"
          :disabled="onAction == true"
          color="success"
          outlined
          @click="requestInvoicing"
          class="mx-2"
        >
          Solicitar Facturación
        </v-btn>
        <v-btn
          v-show="editMode == 'show' && canArchive"
          :disabled="onAction == true"
          color="warning"
          outlined
          @click="archive"
          class="mx-2"
        >
          Anular Pedido
        </v-btn>
        <v-btn
          v-if="false"
          v-show="editMode == 'show' && canUnarchive"
          color="warning"
          outlined
          @click="unarchive"
          class="mx-2"
        >
          Desarchivar
        </v-btn>
        <v-btn
          v-show="
            editMode == 'show' && (canAuthorizeLevel1 || canAuthorizeLevel2)
          "
          :disabled="onAction == true"
          color="success"
          outlined
          @click="authorize"
          class="mx-2"
        >
          Autorizar Descuento LG.
        </v-btn>
        <v-btn
          v-show="editMode == 'show' && canUnAuthorize"
          :disabled="onAction == true"
          color="warning"
          outlined
          @click="unauthorize"
          class="mx-2"
        >
          Rechazar Descuento LG.
        </v-btn>
      </div>
    </v-card>
    <!-- tab0 list -->
    <v-card-text v-show="currentTab === 0">
      <v-card>
        <!-- advanced filter -->
        <v-toolbar>
          <v-autocomplete
            label="Campaña"
            :items="campaignItems"
            :loading="isLoadingCampaign"
            hide-details
            hide-no-data
            hide-selected
            item-text="code"
            item-value="url"
            return-object
            v-model="selectedCampaign"
            @change="campaignSelected($event)"
            @click:prepend="clearAutocomplete('campaignAutocomplete')"
            ref="campaignAutocomplete"
            prepend-icon="mdi-close"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Cultivo"
            :items="cropItems"
            :loading="isLoadingCrops"
            hide-details
            hide-no-data
            hide-selected
            item-text="description"
            item-value="url"
            return-object
            v-model="selectedCrop"
            @change="cropSelected($event)"
            @click:prepend="clearAutocomplete('cropAutocomplete')"
            ref="cropAutocomplete"
            prepend-icon="mdi-close"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Vendedor"
            :items="salesmanItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="description"
            item-value="url"
            v-model="selectedSalesman"
            return-object
            @change="salesmanSelected($event)"
            ref="salesmanAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('salesmanAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Agente"
            :items="dealerItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="name"
            item-value="url"
            v-model="selectedDealer"
            return-object
            @change="dealerSelected($event)"
            ref="dealerAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('dealerAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Cliente"
            :search-input.sync="searchClient"
            :items="clientItems"
            :loading="isLoadingClient"
            hide-details
            hide-no-data
            hide-selected
            item-text="name"
            item-value="url"
            return-object
            @change="clientSelected($event)"
            @click:prepend="clearAutocomplete('clientAutocomplete')"
            ref="clientAutocomplete"
            prepend-icon="mdi-close"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Estado"
            :items="stateItems"
            :loading="isLoadingState"
            hide-details
            hide-no-data
            hide-selected
            item-text="description"
            item-value="url"
            return-object
            @change="stateSelected($event)"
            @click:prepend="clearAutocomplete('stateAutocomplete')"
            ref="stateAutocomplete"
            prepend-icon="mdi-close"
          ></v-autocomplete>
        </v-toolbar>
        <!-- table header pagination and add button -->
        <div class="table-footer-prepend d-flex pl-2 align-center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                :disabled="!enableEditing"
                icon
                outlined
                color="primary"
                class="mr-3"
                v-on="on"
                @click="addNew()"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>Agregar Pedido</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                :disabled="!enableEditing"
                icon
                outlined
                color="primary"
                class="mr-3"
                v-on="on"
                @click="readDataFromAPI()"
              >
                <v-icon>mdi-sync</v-icon>
              </v-btn>
            </template>
            <span>Actualizar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-show="$bRoot.auth.current_level <= 2"
                icon
                outlined
                color="primary"
                class="mr-3"
                v-on="on"
                @click="DownloadInventory()"
              >
                <v-icon>mdi-file-excel-outline</v-icon>
              </v-btn>
            </template>
            <span>Inventario</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-show="$bRoot.auth.current_level <= 2"
                icon
                outlined
                color="primary"
                class="mr-3"
                v-on="on"
                @click="DownloadQuotas()"
              >
                <v-icon>mdi-file-excel-outline</v-icon>
              </v-btn>
            </template>
            <span>Cupos</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-show="$bRoot.auth.current_level <= 2"
                icon
                outlined
                color="primary"
                class="mr-3"
                v-on="on"
                @click="DownloadOrders()"
              >
                <v-icon>mdi-file-excel-outline</v-icon>
              </v-btn>
            </template>
            <span>Pedidos No Informados</span>
          </v-tooltip>
        </div>
        <!-- data table -->
        <v-data-table
          dense
          v-bind:page="page"
          :pageCount="this.pageCount"
          :loading="loading"
          :headers="headers"
          :items="items"
          :itemsPerPage="itemsPerPage"
          :serverItemsLength="serverItemsLength"
          :options.sync="options"
          @click:row="itemSelected($event, false)"
        >
          <template v-slot:top="{ options, updateOptions }">
            <div class="table-footer-append d-flex align-center justify-end">
              <span class="mr-2">{{ getPaginationSummary() }}</span>
              <v-btn
                icon
                small
                class="mr-1"
                :disabled="page <= 1"
                @click="updateOptions(Object.assign({}, options, { page: 1 }))"
              >
                <v-icon>mdi-page-first</v-icon>
              </v-btn>
              <v-btn
                icon
                small
                class="mr-1"
                :disabled="page <= 1"
                @click="updateOptions(Object.assign({}, options, { page: page - 1 }))"
              >
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
              <v-btn
                icon
                small
                class="mr-1"
                :disabled="page >= pageCount"
                @click="updateOptions(Object.assign({}, options, { page: page + 1 }))"
              >
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
              <v-btn
                icon
                small
                class="ml-0"
                :disabled="page >= pageCount"
                @click="updateOptions(Object.assign({}, options, { page: pageCount }))"
              >
                <v-icon>mdi-page-last</v-icon>
              </v-btn>
            </div>
          </template>
          <template v-slot:[`item.visual_state`]="{ item }">
            <v-icon small class="mr-2">
              {{ item.state_icon }}
            </v-icon>
            <span>{{ item.state_description }} </span>
          </template>
          <template v-slot:[`item.observations`]="{ item }">
            <v-icon small class="mr-2">
              {{ getObservationIcon(item) }}
            </v-icon>
            <span>{{ getObservationText(item) }} </span>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon
              v-if="item.can_add_delivery_updates"
              small
              class="mr-2"
              @click.stop="openDeliveryUpdate(item)"
            >
              mdi-truck-delivery
            </v-icon>
            <v-icon
              small
              class="mr-2"
              @click.stop="viewDocumentItem(item)"
              :disabled="!item.invoice"
            >
              mdi-eye-outline
            </v-icon>
          </template>
        </v-data-table>
      </v-card>
    </v-card-text>
    <!-- tab1 edit pedido -->
    <div v-if="currentTab === 1">
      <order-edit
        :initialmode="editMode"
        :value="currentItem"
        :key="currentTab"
        ref="itemEdit"
        @endEdit="endEdit"
        @actionCanceled="actionCanceled"
      >
      </order-edit>
    </div>
    <order-delivery-update
      :show="showOrderDeliveryUpdate"
      :order-id="
        selectedOrderForDeliveryUpdate ? selectedOrderForDeliveryUpdate.id : 0
      "
      @saved="deliveryUpdateSaved"
      @cancel="closeDeliveryUpdate"
    />
  </v-card>
</template>
<script>
import DataOrder from "@/components/clon/DataOrder.js";
import OrderEdit from "@/components/OrderEdit.vue";
import OrderDeliveryUpdate from "@/components/OrderDeliveryUpdate.vue";
import XLSX from "xlsx";

export default {
  name: "Order",

  components: {
    OrderEdit,
    OrderDeliveryUpdate
  },

  data() {
    return {
      currentTab: 0,
      editMode: "show",
      defaultOrder: "-backend_code",
      currentItem: null,
      searchClient: null,
      clientItems: [],
      campaignItems: [],
      stateItems: [],
      cropItems: [],
      salesmanItems: [],
      dealerItems: [],
      lastEndpoint: null,
      selectedCampaign: null,
      selectedCrop: null,
      selectedSalesman: null,
      selectedDealer: null,
      isLoadingClient: false,
      isLoadingCampaign: false,
      isLoadingState: false,
      isLoadingCrops: false,
      filterClient: null,
      filterCampaign: null,
      filterState: null,
      filterCrop: null,
      filterSalesman: null,
      filterDealer: null,
      title: "Pedidos",
      loading: true,
      mounting: true,
      page: 1,
      serverItemsLength: 0,
      pageCount: 0,
      itemsPerPage: 20,
      options: {},
      items: [],
      order: new DataOrder(this.$bRoot),
      enableEditing: false,
      canEdit: false,
      canRequestInvoicing: false,
      canArchive: false,
      canUnarchive: false,
      canAuthorizeLevel1: false,
      canAuthorizeLevel2: false,
      canUnAuthorize: false,
      onAction: false,
      showOrderDeliveryUpdate: false,
      selectedOrderForDeliveryUpdate: null,
      headers: [
        { text: "id", value: "id", sortable: false },
        { text: "Fecha", value: "date_formatted", sortable: false },
        {
          text: "Usuario",
          value: "commercial_person_name",
          sortable: false,
          width: "10%"
        },
        {
          text: "Cliente",
          value: "client_name",
          sortable: false,
          width: "20%"
        },
        {
          text: "Agente",
          value: "dealer_name",
          sortable: false,
          width: "20%"
        },
        {
          text: "Comisión Total USD",
          value: "total_commission_usd",
          sortable: false,
          align: "right",
          width: "10%"
        },
        {
          text: "Reserva Inventario",
          value: "reserving_inventory",
          sortable: false,
          align: "center",
          width: "10%"
        },
        {
          text: "Inventario Faltante",
          value: "insuffisient_inventory",
          sortable: false,
          align: "right"
        },
        {
          text: "Cupo Faltante",
          value: "insuffisient_quota",
          sortable: false,
          align: "right"
        },
        {
          text: "Observaciones",
          value: "observations",
          width: "15%",
          sortable: false
        },
        {
          text: "Estado",
          value: "visual_state",
          sortable: false,
          width: "15%"
        },
        {
          text: "Registración",
          value: "backend_code",
          sortable: false
        },
        { text: "Acciones", value: "actions", sortable: false }
      ],
      canDelete: false,
      downloading: false
    };
  },

  //this one will populate new data set when user changes current page.
  watch: {
    options: {
      handler(options) {
        let order_by = "";
        let order_desc = 0;

        if (options.sortBy.length > 0) {
          order_by = options.sortBy[0];
          order_desc = options.sortDesc[0] ? 1 : 0;
        } else {
          order_by = this.defaultOrder;
          order_desc = 0;
        }
        this.readDataFromAPI(false, order_by, order_desc);
      }
    },
    searchClient: {
      handler(val) {
        this.doIntelliSearch("client", val);
      }
    },
    deep: true
  },

  methods: {
    //Reading data from API method.
    async readDataFromAPI(reset, order_by, order_desc) {
      if (!this.mounting) {
        try {
          this.loading = true;
          this.items = [];
          if (this.filterCampaign) {
            if (!order_by) {
              order_by = this.defaultOrder;
            } else {
              order_by = (order_desc == 1 ? "-" : "") + order_by;
            }
            const { page, itemsPerPage } = this.options;
            let pageNumber = reset ? 1 : page;
            this.loading = true;
            let campaign_id = this.filterCampaign ? this.filterCampaign.id : 0;
            let cliente_id = this.filterClient ? this.filterClient.id : 0;
            let state_id = this.filterState ? this.filterState.id : 0;
            let crop_id = this.filterCrop ? this.filterCrop.id : 0;
            let salesman_id = this.filterSalesman ? this.filterSalesman.salesman_id : 0; //eslint-disable-line
            let dealer_id = this.filterDealer ? this.filterDealer.dealer_id : 0;

            let res = await this.order.search(
              campaign_id,
              cliente_id,
              state_id,
              crop_id,
              salesman_id,
              dealer_id,
              order_by,
              pageNumber
            );
            if (this.$bRoot.errors) {
              throw "Error recuperando datos";
            }
            if (res) {
              this.items = res.data.results;
              this.serverItemsLength = res.data.count;
              this.page = pageNumber;
              this.pageCount = Math.ceil(res.data.count / itemsPerPage);
            }
          }
        } catch (error) {
          if (!this.$bRoot.errors) {
            this.$bRoot.setError(error);
          }
        } finally {
          this.loading = false;
        }
      }
    },

    doIntelliSearch(field, val) {
      // Items have already been requested
      if (this.isLoading) return;

      // Lazily load input items
      let endpoint = null;
      let searchstring = null;
      let filterstring = null;
      let ordering = null;

      switch (field) {
        case "client":
          if (this.filterClient) {
            if (this.filterClient.name === val) return;
          }
          /*OJO debería buscar únicamente entre los clientes asignados al comercial*/
          endpoint = "/data/extended_clients";
          searchstring = val;
          ordering = "name";
          this.isLoadingClient = true;
          break;
      }

      // eslint-disable-next-line
      this.$bRoot.search(endpoint, searchstring, ordering, filterstring, 1)
        .then(res => {
          switch (field) {
            case "client":
              this.clientItems = res.data.results;
              break;
          }
        })
        .catch(err => {
          if (!this.$bRoot.errors) {
            this.$bRoot.setError(err);
          }
        })
        .finally(() => {
          this.isLoadingClient = false;
        });
    },

    clearAutocomplete(field) {
      this.$refs[field].internalValue = [];
      switch (field) {
        case "clientAutocomplete":
          this.filterClient = null;
          break;
        case "campaignAutocomplete":
          this.filterCampaign = null;
          this.filterSalesman = null;
          this.filterDealer = null;
          this.loadSalesmans();
          this.loadDealers();
          break;
        case "stateAutocomplete":
          this.filterState = null;
          break;
        case "cropAutocomplete":
          this.filterCrop = null;
          this.filterDealer = null;
          this.loadDealers();
          break;
        case "salesmanAutocomplete":
          this.filterSalesman = null;
          break;
        case "dealerAutocomplete":
          this.filterDealer = null;
          break;
      }
      this.readDataFromAPI(true);
    },

    clientSelected(item) {
      this.filterClient = item;
      this.readDataFromAPI(true);
    },

    campaignSelected(campaign) {
      this.filterCampaign = campaign;
      this.loadSalesmans();
      this.loadDealers();
      this.readDataFromAPI(true);
    },

    cropSelected(crop) {
      this.filterCrop = crop;
      this.loadDealers();
      this.readDataFromAPI(true);
    },

    stateSelected(state) {
      this.filterState = state;
      this.readDataFromAPI(true);
    },

    salesmanSelected(item) {
      this.filterSalesman = item;
      this.readDataFromAPI(true);
    },

    dealerSelected(item) {
      this.filterDealer = item;
      this.readDataFromAPI(true);
    },

    deleteItem(item) {
      this.$emit("deleteItem", item);
    },

    async itemSelected(item, edit) {
      this.editMode = edit ? "edit" : "show";
      let currentItem = Object.assign({}, item);
      let campaign_id = this.filterCampaign ? this.filterCampaign.id : 0;
      this.currentItem = await this.order.get(campaign_id, currentItem.id);
      if (this.enableEditing) {
        this.canEdit = item.can_edit;
        this.canRequestInvoicing = item.can_request_invoicing;
        this.canArchive = item.can_edit;
        this.canUnarchive = item.can_unarchive;
        this.canAuthorizeLevel1 = item.can_authorize_level_1;
        this.canAuthorizeLevel2 = item.can_authorize_level_2;
        this.canUnAuthorize = item.can_unauthorize;
      } else {
        this.canEdit = false;
        this.canRequestInvoicing = false;
        this.canArchive = false;
        this.canUnarchive = false;
        this.canAuthorizeLevel1 = false;
        this.canAuthorizeLevel2 = false;
        this.canUnAuthorize = false;
      }
      this.currentTab = 1;
    },

    openDeliveryUpdate(item) {
      this.selectedOrderForDeliveryUpdate = item;
      this.showOrderDeliveryUpdate = true;
    },

    closeDeliveryUpdate() {
      this.showOrderDeliveryUpdate = false;
      this.selectedOrderForDeliveryUpdate = null;
    },

    async deliveryUpdateSaved() {
      this.closeDeliveryUpdate();
    },

    async addNew() {
      this.currentItem = await this.order.initialize(
        this.filterClient,
        this.filterCampaign,
        this.filterCrop,
        "NV"
      );
      this.editMode = "new";
      this.currentTab = 1;
    },

    async loadSalesmans() {
      this.salesmanItems = [];
      this.selectedSalesman = null;
      this.filterSalesman = null;
      let salesmans = null;
      if (this.filterCampaign) {
        salesmans = await this.$bRoot.search(
          "/data/salesman_campaign_hierarchy",
          null,
          null,
          "campaign__id=" + this.filterCampaign.id.toString()
        );
        this.salesmanItems = salesmans.data.results;
      }
    },

    async loadDealers() {
      this.dealerItems = [];
      this.filterDealer = null;
      this.selectedDealer = null;
      let dealers = null;
      if (this.filterCampaign && this.filterCrop) {
        dealers = await this.$bRoot.search(
          "/data/dealers_campaign_crop_hierarchy" +
            "/" +
            this.filterCampaign.id.toString() +
            "/" +
            this.filterCrop.id.toString(),
          null,
          null
        );
        if (dealers.data) {
          this.dealerItems = dealers.data;
        }
      }
    },

    async DownloadInventory() {
      try {
        this.loading = true;
        let endpoint =
          "/data/inventories_search" +
          "/" +
          (this.filterCampaign ? this.filterCampaign.id.toString() : "0") +
          "/" +
          (this.filterCrop ? this.filterCrop.id.toString() : "0") +
          "/0/0/0/0/-2/-1/0/0";

        // eslint-disable-next-line
        let raw = await this.$bRoot.searchAll(endpoint, null, null, null, null);
        let craw = [];
        if (raw.length > 0) {
          // crop atributos
          craw = raw.map(e => {
            return this.sliceObj(
              e,
              "campaign_code",
              "product_code",
              "product_description",
              "gauge_code",
              "gauge_description",
              "curing_code",
              "curing_description",
              "crop_description",
              "band_description",
              "serial_number",
              "client_name",
              "sector_description",
              "inventory_amount",
              "reserved_amount_softland",
              "reserved_amount_clon",
              "available_amount"
            );
          });
          let datosWS = XLSX.utils.json_to_sheet(craw);
          let wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, datosWS, "inventario");
          XLSX.writeFile(wb, "inventario.xlsx");
        }
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
      } finally {
        this.loading = false;
      }
    },

    sliceObj(obj) {
      var o = {},
        keys = [].slice.call(arguments, 1);
      // eslint-disable-next-line
      for (var i=0; i<keys.length; i++) {
        if (keys[i] in obj) o[keys[i]] = obj[keys[i]];
      }
      return o;
    },

    async DownloadQuotas() {
      try {
        if (!this.filterCampaign) {
          this.$bRoot.setError("Indique Campaña");
          return;
        }
        if (!this.filterCrop) {
          this.$bRoot.setError("Indique Cultivo");
        }
        this.loading = true;
        let endpoint =
          "/data/quotas_download/" +
          this.filterCampaign.id.toString() +
          "/" +
          this.filterCrop.id.toString();

        // eslint-disable-next-line
        let raw = await this.$bRoot.search(endpoint, null, null, null, null);
        let datosWS = XLSX.utils.json_to_sheet(raw.data);
        let wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, datosWS, "cupos");
        XLSX.writeFile(wb, "cupos.xlsx");
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
      } finally {
        this.loading = false;
      }
    },

    async DownloadOrders() {
      try {
        this.loading = true;
        let endpoint =
          "/data/orders_download/" +
          (this.filterCampaign ? this.filterCampaign.id.toString() : "0") +
          "/" +
          (this.filterCrop ? this.filterCrop.id.toString() : "0");

        // eslint-disable-next-line
        let raw = await this.$bRoot.search(endpoint, null, null, null, null);
        let datosWS = XLSX.utils.json_to_sheet(raw.data);
        let wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, datosWS, "pedidos");
        XLSX.writeFile(wb, "pedidos.xlsx");
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
      } finally {
        this.loading = false;
      }
    },

    async cancel() {
      // eslint-disable-next-line
      if(this.editMode === 'show' || await this.$confirm("Confirme que desea abandonar la edición, los datos modificados se perderán")) {
        this.endEdit();
      }
    },

    edit() {
      if (this.currentItem && this.currentTab === 1) {
        this.editMode = "edit";
        this.$refs.itemEdit.mode = "edit";
        this.$refs.itemEdit.editing = true;
      }
    },

    async endEdit() {
      this.editMode = null;
      this.currentItem = null;
      this.error = null;
      this.currentTab = 0;
      await this.readDataFromAPI();
      this.onAction = false;
    },

    async save() {
      this.onAction = true;
      await this.$refs.itemEdit.save();
    },

    async actionCanceled() {
      this.onAction = false;
    },

    async requestInvoicing() {
      this.onAction = true;
      let state_code = this.currentItem.has_company_discount ? 20 : 40;
      await this.$refs.itemEdit.changeState(state_code);
    },

    async archive() {
      this.onAction = true;
      await this.$refs.itemEdit.changeState(100);
    },

    async unarchive() {
      this.onAction = true;
      await this.$refs.itemEdit.changeState(10);
    },

    async authorize() {
      this.onAction = true;
      let state_code = this.canAuthorizeLevel1 ? 25 : 40;
      await this.$refs.itemEdit.changeState(state_code);
    },

    async unauthorize() {
      this.onAction = true;
      await this.$refs.itemEdit.changeState(30);
    },

    getObservationIcon(item) {
      if (
        item.campaign_total_quantity < item.total_quantity &&
        item.state_allows_editing
      ) {
        return "mdi-alert-circle-outline";
      } else {
        return null;
      }
    },

    getObservationText(item) {
      if (item.errors) {
        return item.errors;
      } else if (
        item.campaign_total_quantity < item.total_quantity &&
        item.state_allows_editing
      ) {
        return "Error en descuento por volúmen";
      } else {
        return null;
      }
    },

    getPaginationSummary() {
      if (this.serverItemsLength === 0) {
        return "0-0 of 0";
      }

      const fromItem = (this.page - 1) * this.itemsPerPage + 1;
      const toItem = Math.min(this.page * this.itemsPerPage, this.serverItemsLength);
      return fromItem + "-" + toItem + " of " + this.serverItemsLength;
    },

    viewDocumentItem(args) {
      window.open(args.invoice, "_blank", "noreferrer");
    }
  },

  async mounted() {
    var main_container = document.getElementById("app");
    main_container.classList.remove("home");

    // evaluete enableEditing
    this.enableEditing = true;
    if (
      this.$bRoot.appInfo.commercial_person.commercial_person_type.level > 2 &&
      !this.$bRoot.appInfo.commercial_person.can_edit_orders
    ) {
      this.enableEditing = false;
    }

    //campaigns
    let campaigns = await this.order.getCampaigns();
    this.campaignItems = campaigns.data.results;
    let defaultCampaignId = this.$bRoot.getUserParam("defaultCampaignId");
    let index = this.campaignItems.findIndex(
      item => item.id == defaultCampaignId
    );
    if (index == -1 && this.campaignItems.length > 0) {
      index = 0;
    }
    if (index !== -1) {
      this.selectedCampaign = this.campaignItems[index].url;
      this.filterCampaign = this.campaignItems[index];
    }
    this.mounting = false;

    //crops
    let crops = await this.order.getCrops();
    this.cropItems = crops.data.results;
    // default value
    let default_crop_id = this.$bRoot.getUserParam("defaultCropId");
    if (default_crop_id) {
      let index = this.cropItems.findIndex(
        crop_item => crop_item.id === default_crop_id
      );
      if (index != -1) {
        this.selectedCrop = this.cropItems[index].url;
        this.filterCrop = this.cropItems[index];
      }
    }

    //Rate Value
    let rateValue = await this.order.getRateValue();
    if (rateValue) {
      this.title =
        " (Cotización USD al " +
        this.$bRoot.moment.utc(rateValue.effective_date).format("DD/MM/YYYY") +
        ": " +
        parseFloat(rateValue.value).toLocaleString("es-AR", {
          minimumFractionDigits: 2
        }) +
        ") ";
    }

    //states
    this.isLoadingState = true;
    let states = await this.order.getStates();
    this.stateItems = states.data.results;
    this.isLoadingState = false;

    //Salesmans and Dealers
    await this.loadSalesmans();
    await this.loadDealers();

    await this.readDataFromAPI();
  }
};
</script>

<style scoped>
.v-data-footer__select {
  display: none !important;
}
.v-data-footer:last-child {
  visibility: hidden !important;
}
.table-footer-prepend {
  height: 58px;
}
.table-footer-append {
  min-height: 58px;
}
.v-data-table {
  margin-top: -58px;
}
</style>
